<template>
  <div id="basic">
    <div class="top_div">
      <el-form :inline="true" :model="formInline">
        <div class="demo-form-inline">
          <el-form-item label="公司名称:">
            <el-input v-model="formInline.user" placeholder="请输入"></el-input>
          </el-form-item>
          <el-form-item style="min-width: 150px; margin-left: 20px;">
            <el-button
              type="primary"
              style="background: #1890ff;"
              @click="onSubmit"
              >查询</el-button
            >
            <el-button type="primary" class="vubutton" @click="onSubmit"
              >重置</el-button
            >
          </el-form-item>
        </div>
        <div class="bottom_center">
          <el-button
            type="primary"
            class="vubutton"
            :header-cell-style="() => 'text-align: center;background:#eef1f6;'"
            @click="onSubmit"
            >+新建公司</el-button
          >
        </div>
      </el-form>

      <el-table
        :fit="false"
        border
        :data="tableData"
        style="width: auto;"
        :cell-style="() => 'text-align: center;'"
        :header-cell-style="() => 'text-align: center;background:#eef1f6;'"
      >
        <template slot="empty">
          <noCart></noCart>
        </template>
        <el-table-column label="公司名称" width="180">
          <template slot-scope="scope">
            <span>{{ scope.row.date }}</span>
          </template>
        </el-table-column>
        <el-table-column label="公司地址" width="180">
          <template slot-scope="scope">
            <span>{{ scope.row.name }}</span>
          </template>
        </el-table-column>
        <el-table-column label="联系人" width="180">
          <template slot-scope="scope">
            <span>{{ scope.row.name }}</span>
          </template>
        </el-table-column>
        <el-table-column label="联系方式" width="180">
          <template slot-scope="scope">
            <span>{{ scope.row.name }}</span>
          </template>
        </el-table-column>

        <el-table-column label="操作">
          <template slot-scope="scope">
            <el-button size="mini" @click="handleEdit(scope.$index, scope.row)"
              >编辑</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        class="pagination"
        background
        layout="prev, pager, next"
        :total="1000"
      ></el-pagination>
    </div>
  </div>
</template>

<script>
export default {
  name: 'employee',
  data() {
    return {
      formInline: {
        user: '',
        region: '',
      },
      tableData: []
    };
  },
  methods: {
    onSubmit() {
      console.log('submit!');
    },
    handleEdit(index, row) {
      console.log(index, row);
    },
    handleDelete(index, row) {
      console.log(index, row);
    },
  },
};
</script>

<style scoped>
#basic {
  width: 100%;
  height: 100%;
  position: relative;
}
.top_div {
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  padding: 20px;
  background: #fff;
}
.demo-form-inline {
  display: flex;
  justify-content: flex-start;
}
/* .el-select > .el-input,
.el-input__inner {
  width: 300px;
} */
.vubutton {
  background: #fff;
  border: solid 1px #1890ff;
  color: #1890ff;
}
.el-button--primary:hover,
.el-button--primary:active,
.el-button--primary:focus {
  background: #1890ff;
  border-color: #1890ff;
}
.el-table--group::after,
.el-table--border::after,
.el-table::before {
  background: none;
}
.el-form--inline .el-form-item {
  margin-right: 50px;
}
.center_div {
  margin-top: 20px;
  background: #fff;
  box-sizing: border-box;
  padding: 20px;
}
.el-table__empty-block {
  width: none !important;
}
.center_div_border {
  margin-top: 20px;
  width: 100%;
  min-height: 300px;
  background: brown;
}
.pagination {
  margin-top: 20px;
  text-align: center;
}
.bottom_center {
  width: 100%;
  display: flex;
  justify-content: space-between;
  margin-bottom: 20px;
}
</style>
